import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AdminService } from '../../service/admin.service';
import { UtilService } from '../../service/util.service';
import * as constants from '../../app.constants';
import { NotificationsService } from 'angular2-notifications';
import { PagerService } from '../../pipe/pagination';
import { IMyDpOptions } from 'mydatepicker';
import { User } from '../../model/user';
declare let $: any;

@Component({
  selector: 'users',
  template: require('./user.component.html'),
  styles: [require('./user.component.css')]
})

export class UserComponent implements OnInit {

  public users: User[];
  public page: number; // Current Page
  public pageSize: number; // Number of items per page
  public count: number; // Number of items in result
  public pager: any = {};
  public message: string = constants.messages.loading;
  public errorMsg: string;
  public pageSizes: number[];
  public showLoader: boolean;
  srchPhno:any="";

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public _notificationsService: NotificationsService,
    private adminService: AdminService,
    private pagerService: PagerService) {
      // Initialize fields
      this.page = 1;
      this.pageSize = 10;
      this.pageSizes = [10, 20, 50, 100];
  }

  public ngOnInit(): void {
    // Show users with default page number and size
    this.getUsers();
  }

  public getUsers(selectedPage?: number, newPazeSize?: number): void {
    console.debug('Get list of user');
    selectedPage = selectedPage ? selectedPage : this.page;
    newPazeSize = newPazeSize ? newPazeSize : this.pageSize;
    let pageOptions = {
      page: selectedPage,
      page_size: newPazeSize
    };
    let url="";
    if(this.srchPhno.length>0)
    {
      url=constants.URLs.userList + '?' + $.param(pageOptions) +"&search="+this.srchPhno;
    }
    else
    {
      url = constants.URLs.userList + '?' + $.param(pageOptions);
    }
    
    this.showLoader = true;
    this.adminService
      .getCall(url, true)
      .then((res) => {
          console.log('getUsers res');
          console.log(res);
          this.showLoader = false;
          this.count = res.count;
          this.users = res.results;
          this.message = null;
          this.page = selectedPage;
          this.pageSize = newPazeSize;
          this.pager = this.pagerService.getPager(this.count, selectedPage, newPazeSize);
      })
      .catch((error: any) => {
          console.error('UserComponent- an error occurred', error);
          this.showLoader = false;
          try {
            this.errorMsg = error.json().error_msg || constants.messages.serverError;
          } catch (e) {
            this.errorMsg = error.message ? error.message : constants.messages.serverError;
          }
      });
  }

  public goToPage(selectedPage: number) {
    if (this.pager.currentPage === selectedPage) {
      return;
    }
    if (selectedPage < 1 || selectedPage > this.pager.totalPages) {
      return;
    }
    // Show users with selected page number and existing page size
    this.getUsers(selectedPage);
  }

  public onPageSizeChange(newPazeSize: number): void {
    console.log(newPazeSize);
    this.getUsers(1, newPazeSize);
  }

  public onStatusChange(user: User): void {
    console.debug(`Update user ${user.user_id} status ${user.is_active}`);
    let url = constants.URLs.userUpdateStatus.replace('{user_id}', user.user_id);
    console.debug(url);
    let model = {
      is_active: user.is_active
    };
    this.adminService
    .putCall(url, model, true)
    .then((res) => {
        console.log('Update user status res');
        console.log(res);
        this.adminService.showSuccessToast(constants.messages.userStatusUpdate);
    })
    .catch((error: any) => {
      user.is_active = !user.is_active; // Revert the change
      try {
        this.errorMsg = error.json().error_msg || constants.messages.serverError;
        console.debug('UserComponent- an error occurred', error);
      } catch (e) {
        this.errorMsg = error.message ? error.message : constants.messages.serverError;
        console.error('UserComponent- an error occurred', error);
      }
      this.adminService.showErrorToast(this.errorMsg);
    });
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/manage/users/user.component.ts